<style lang="scss">
.newsInnerContent {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media screen and (min-width: 55rem) {
    .newsInnerContent-list {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      .newsInnerContent-left {
        box-shadow: 0px 3px 5px #a3a0a0;
        width: 30%;
        max-height: 30rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        position: relative;
        .newsInnerContent-left-container {
          width: 98%;
          .newsInnerContent-image {
            width: 100%;
            height: 20rem;
            background-image: url("/media/yintai/newsinner.png");
            background-size: cover;
            background-position: center center;
          }
          .newsInnerContent-title {
            font-size: 1.4rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: bold;
            color: #4b4b4b;
            margin-top: 1rem;
          }
        }
        .newsInnerContent-line {
          position: absolute;
          width: 4rem;
          height: 0.4rem;
          bottom: 0;
          right: 10%;
          background-color: #e5004f;
        }
      }
      .newsInnerContent-right {
        width: 60%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .newsInnerContent-subtitle {
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #e5004f;
          line-height: 28px;
          text-transform: uppercase;
          margin-top: 2rem;
        }
        .newsInnerContent-title {
          font-size: 1.6rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: bold;
          color: #4b4b4b;
          margin-top: 1rem;
          margin-bottom: 1rem;
        }
        .newsInnerContent-line {
          width: 2rem;
          height: 0.2rem;
          background-color: #e5004f;
          margin-bottom: 2rem;
        }
        .newsInnerContent-text {
          width: 80%;
          font-size: 1rem;
          line-height: 1.6rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 400;
          color: #7f7f7f;
          text-align: justify;
          text-justify: auto;
        }
      }
    }
  }
  @media screen and (max-width: 55rem) {
    .newsInnerContent-list {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .newsInnerContent-left {
        box-shadow: 0px 3px 5px #a3a0a0;
        width: 100%;
        height: 30rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        position: relative;
        .newsInnerContent-left-container {
          width: 98%;
          .newsInnerContent-image {
            width: 100%;
            height: 70%;
            background-image: url("/media/yintai/newsinner.png");
            background-size: 100% 100%;
            background-size: cover;
          }
          .newsInnerContent-title {
            font-size: 1.4rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: bold;
            color: #4b4b4b;
            margin-top: 1rem;
          }
        }
        .newsInnerContent-line {
          position: absolute;
          width: 4rem;
          height: 0.4rem;
          bottom: 0;
          right: 10%;
          background-color: #e5004f;
        }
      }
      .newsInnerContent-right {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .newsInnerContent-subtitle {
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #e5004f;
          line-height: 28px;
          text-transform: uppercase;
          margin-top: 2rem;
        }
        .newsInnerContent-title {
          font-size: 1.6rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: bold;
          color: #4b4b4b;
          margin-top: 1rem;
          margin-bottom: 1rem;
        }
        .newsInnerContent-line {
          width: 2rem;
          height: 0.2rem;
          background-color: #e5004f;
          margin-bottom: 2rem;
        }
        .newsInnerContent-text {
          width: 100%;
          line-height: 1.6rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 400;
          color: #7f7f7f;
          text-align: justify;
          text-justify: auto;
        }
      }
    }
  }
}
</style>

<template>
  <div class="newsInnerContent">
    <div class="newsInnerContent-list">
      <div class="newsInnerContent-left">
        <div class="newsInnerContent-left-container">
          <div
            class="newsInnerContent-image"
            :style="`background-image:url('${news.picture_url}')`"
          ></div>
          <div class="newsInnerContent-title">{{ news.title }}</div>
        </div>
        <div class="newsInnerContent-line"></div>
      </div>
      <div class="newsInnerContent-right">
        <div class="newsInnerContent-subtitle">Intime News</div>
        <div class="newsInnerContent-title">{{ news.title }}</div>
        <div class="newsInnerContent-line"></div>
        <div class="newsInnerContent-text" v-html="news.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { findNewsById } from "@/yintai/api/news";
export default {
  name: "newsInnerContent",
  components: {},
  data() {
    return {
      news: {},
    };
  },
  async mounted() {
    let id = this.$route.query.id;
    const result = await findNewsById({ id });
    this.news = result.data.data.item;
  },
  methods: {},
};
</script>
